import DOMHelper from "../../lib/dom-helper";
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.min.js';
import { EasingFunctions } from "../../lib/animation-module";

class ButtonUp {
	constructor() {
		this.$root = document.getElementById('buttonUp');
		this.$postEntry = document.querySelector('.section.-post-entry');

		this.smoothScroll = new SmoothScroll();

		if (this.$root) {
			this.init();
		}
	}

	init() {
		this.$root.addEventListener('click', () => {
			const windowYPos = window.scrollY;
			const postEntryYPos = DOMHelper.getElementTopPosition(this.$postEntry) - 41;
			if (windowYPos > postEntryYPos + 50) {
				this.smoothScroll.animateScroll(postEntryYPos, null, {
					speed: 360,
					customEasing: EasingFunctions.primary
				});
			}
		});
	}
}

export default class AsideControls {
	constructor() {
		this.mediaMobileLg = window.matchMedia('(max-width: 600px)').matches;

		this.buttonUp = null;

		this.init();
	}

	init() {
		this.initButtonUp();

		window.addEventListener('resize', () => {
			this.mediaMobileLg = window.matchMedia('(max-width: 600px)').matches;

			this.initButtonUp();
		});
	}

	initButtonUp() {
		if (!this.mediaMobileLg && !this.buttonUp) {
			this.buttonUp = new ButtonUp();
		}
	}
}